export default __webpack_public_path__ + "assets/arrow-down.7bf6f5242cfe68aa8e2d6cd331e0303b.svg";